import React, { useState, useEffect, useContext, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./../../Pages/PrintForm/printForm.css";
import SignContext from "../../../contextAPI/Context/SignContext";
import { Link, useParams } from "react-router-dom";
import img from "./logo.png";
import signature from "../../../assets/images/OPD sign.jpg";
import { set } from "date-fns";

const MediclaCheckUp = () => {
  const { id } = useParams();
  const { getCheckupDatabyId } = useContext(SignContext);
  const [CheckupData, setCheckupData] = useState(null);
  const [wantsignature, setWantsignature] = useState(true);
  const isPrinting = useRef(false);

  const [withGlassChecked, setWithGlassChecked] = useState(false);
  const [withoutGlassChecked, setWithoutGlassChecked] = useState(false);
  const [nearwith, setNearwith] = useState(false);
  const [nearwithout, setNearwithout] = useState(false);

  const gettingdata = async () => {
    const data = await getCheckupDatabyId(id);
    setCheckupData(data);
  };

  useEffect(() => {
    gettingdata();
  }, [id]);

  useEffect(() => {
    if (!CheckupData) return;
    const eye = CheckupData.employeeeyeinformation || {};
    setWithGlassChecked(!!eye.distandVisionWithLeftEye);
    setWithoutGlassChecked(!!eye.distandVisionWithoutLeftEye);
    setNearwith(!!eye.nearVisionWithLeftEye);
    setNearwithout(!!eye.nearVisionWithoutLeftEye);
  }, [CheckupData]);

  const handlePrint = () => {
    window.print();
  };

  const handlePrintWithSignature = () => {
    setWantsignature(true);
    isPrinting.current = true;
    setTimeout(handlePrint, 200);
  };

  const handlePrintWithoutSignature = () => {
    setWantsignature(false);
    isPrinting.current = true;
    setTimeout(handlePrint, 200);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mainDivMediclaForm">

            {/* HEADER */}
            <div className="header-section">
              <div className="logo-part" style={{ display: "inline-block" }}>
                <img style={{ width: "80px" }} src={img} alt="logo" />
              </div>
              <div
                className="heading-part"
                style={{ display: "inline-block", position: "relative", top: 24, left: 15 }}
              >
                <h1>VIRAJ</h1>
                <h5>OCCUPATIONAL HEALTH SERVICES</h5>
              </div>
            </div>
            <br />

            {/* TITLE */}
            <div className="titleDiv">
              <h5 className="medicalTitle" style={{ marginLeft: 239 }}>
                MEDICAL CHECK UP
              </h5>
              <h6 className="medicalSubTitle">
                Sr.No.: {CheckupData?.employeeData?.srNo}
              </h6>
            </div>

            <div className="table-container">

              {/* BIO-DATA */}
              <table className="Medical-checkup1">
                <tr>
                  <td rowSpan="6" style={{ width: "5%" }}>
                    <div className="sideTitle">BIO-DATA</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    DATE:{" "}
                    {CheckupData?.checkupDate
                      ? CheckupData.checkupDate.slice(0,10).split("-").reverse().join("-")
                      : "N/A"}
                  </td>
                  <td colSpan="3">
                    MOB: {CheckupData?.employeecontactdetails?.mobileNumber || "N/A"}
                  </td>
                  <td colSpan="3">
                    DOB:{" "}
                    {CheckupData?.employeecontactdetails?.dateOfBirth
                      ?.slice(0,10)
                      .split("-")
                      .reverse()
                      .join("-") || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="9">
                    NAME: {CheckupData?.employeeData?.employeeNameAbbrevation || "N/A"}{" "}
                    {CheckupData?.employeeData?.employeeName || "N/A"}{" "}
                    {CheckupData?.employeeData?.employeeFatherName || "N/A"}{" "}
                    {CheckupData?.employeeData?.employeeSurname || "N/A"}
                  </td>
                  <td colSpan="3">
                    SEX: {CheckupData?.employeecontactdetails?.gender || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="9">
                    COMPANY: {CheckupData?.compani?.companyName || "N/A"},
                    {CheckupData?.employeeData?.companyLocation || "N/A"}-
                    {CheckupData?.employeeData?.ecNo || ""}
                  </td>
                  <td colSpan="3">
                    AGE: {CheckupData?.employeecontactdetails?.age || "N/A"}YRS
                  </td>
                </tr>
                <tr>
                  <td colSpan="9">
                    NATURE OF JOB: {CheckupData?.employeecontactdetails?.natureOfJob || "N/A"}
                  </td>
                  <td colSpan="3">
                    HT: {CheckupData?.employeeVitalAndHistory?.height || "N/A"} CMS
                  </td>
                </tr>
                <tr>
                  <td colSpan="9">
                    IDENTIFICATION MARK: {CheckupData?.employeecontactdetails?.idMark || "N/A"}
                  </td>
                  <td colSpan="1">
                    WT: {CheckupData?.employeeVitalAndHistory?.weight || "N/A"} KG
                  </td>
                  <td colSpan="2">
                    BMI: {CheckupData?.employeeVitalAndHistory?.bmi || "N/A"}
                  </td>
                </tr>
              </table>

              {/* HISTORY */}
              <table className="Medical-checkup">
                <tr>
                  <td rowSpan="6" style={{ width: "5%" }}>
                    <div className="sideTitle">HISTORY</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="12">
                    COMPLAINTS: {CheckupData?.employeeVitalAndHistory?.complaints || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="12">
                    PAST HISTORY: {CheckupData?.employeeVitalAndHistory?.pastHistory || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="12">
                    PERSONAL HISTORY: {CheckupData?.employeeVitalAndHistory?.personalHistory || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="12">
                    FAMILY HISTORY: {CheckupData?.employeeVitalAndHistory?.familyHistory || "N/A"}
                  </td>
                </tr>
              </table>

              {/* EXAMINATION & VISION */}
              <table className="Medical-checkup">
                <tr>
                  <td rowSpan="12" style={{ width: "5%" }}>
                    <div className="sideTitle">EXAMINATION</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    BP: {CheckupData?.employeeVitalAndHistory?.bp || "N/A"}{" "}
                    <span className="abc">mm of Hg</span>
                  </td>
                  <td colSpan="3">
                    PULSE: {CheckupData?.employeeVitalAndHistory?.pulse || "N/A"}{" "}
                    <span className="abc">per Min.</span>
                  </td>
                  <td colSpan="3">
                    TEM: {CheckupData?.employeeVitalAndHistory?.temperature || "N/A"}{" "}
                    <span className="abc">
                      <sup>0</sup>f
                    </span>
                  </td>
                </tr>
                <tr>
                  <td colSpan="12">
                    General Examination:{" "}
                    {CheckupData?.employeegeneralexamination?.generalExam || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    Cardio Vascular System:{" "}
                    {CheckupData?.employeegeneralexamination?.cvs || "N/A"}
                  </td>
                  <td colSpan="6">
                    Respiratory System:{" "}
                    {CheckupData?.employeegeneralexamination?.rs || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    Alimentary System:{" "}
                    {CheckupData?.employeegeneralexamination?.abdomenAS || "N/A"}
                  </td>
                  <td colSpan="6">
                    Central Nervous System:{" "}
                    {CheckupData?.employeegeneralexamination?.cns || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    Loco-motor System:{" "}
                    {CheckupData?.employeegeneralexamination?.musculoSkeletal || "N/A"}
                  </td>
                  <td colSpan="6">
                    Skin:{" "}
                    {CheckupData?.employeegeneralexamination?.skinAndGenitals || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    ENT: {CheckupData?.employeegeneralexamination?.ent || "N/A"}
                  </td>
                  <td colSpan="6">
                    Genitals / Other:{" "}
                    {CheckupData?.employeegeneralexamination?.other || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="12">
                    Eye Examination (External):{" "}
                    {CheckupData?.employeeeyeinformation?.externalexamination || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">Acuity of Vision:</td>
                  <td colSpan="3">RT EYE:</td>
                  <td colSpan="3">LT EYE:</td>
                </tr>
                <tr>
                  <td colSpan="6">
                    <div className="titleDiv">
                      Distant Vision With Glass&nbsp;
                      <span style={{ fontSize: 18 }}>
                        {withGlassChecked ? "☑" : "☐"}
                      </span>
                      &nbsp;Without Glass&nbsp;
                      <span style={{ fontSize: 18 }}>
                        {withoutGlassChecked ? "☑" : "☐"}
                      </span>
                    </div>
                  </td>
                  <td colSpan="3">
                    6/
                    {CheckupData?.employeeeyeinformation?.distandVisionWithoutRightEye ||
                      CheckupData?.employeeeyeinformation?.distandVisionWithRightEye ||
                      "N/A"}
                  </td>
                  <td colSpan="3">
                    6/
                    {CheckupData?.employeeeyeinformation?.distandVisionWithoutLeftEye ||
                      CheckupData?.employeeeyeinformation?.distandVisionWithLeftEye ||
                      "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    <div className="titleDiv">
                      Near Vision With Glass&nbsp;
                      <span style={{ fontSize: 18 }}>
                        {nearwith ? "☑" : "☐"}
                      </span>
                      &nbsp;Without Glass&nbsp;
                      <span style={{ fontSize: 18 }}>
                        {nearwithout ? "☑" : "☐"}
                      </span>
                    </div>
                  </td>
                  <td colSpan="3">
                    N/
                    {CheckupData?.employeeeyeinformation?.nearVisionWithoutRightEye ||
                      CheckupData?.employeeeyeinformation?.nearVisionWithRightEye ||
                      "N/A"}
                  </td>
                  <td colSpan="3">
                    N/
                    {CheckupData?.employeeeyeinformation?.nearVisionWithoutLeftEye ||
                      CheckupData?.employeeeyeinformation?.nearVisionWithLeftEye ||
                      "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="12">
                    <div className="inputDiv">
                      Colour Vision:&nbsp;
                      <span style={{ fontSize: 18 }}>
                        {CheckupData?.employeeeyeinformation?.colourVision?.toUpperCase() ===
                        "NORMAL"
                          ? "☑"
                          : "☐"}
                      </span>
                      &nbsp;Normal&nbsp;&nbsp;
                      <span style={{ fontSize: 18 }}>
                        {CheckupData?.employeeeyeinformation?.colourVision?.toUpperCase() !==
                        "NORMAL"
                          ? "☑"
                          : "☐"}
                      </span>
                      &nbsp;Colour Vision Deficiency
                    </div>
                  </td>
                </tr>
              </table>

              {/* CONCLUSION */}
              <table className="Medical-checkup">
                <tr>
                  <td rowSpan="6" style={{ width: "5%" }}>
                    <div className="sideTitle">CONCLUSION</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    Remark:{" "}
                    {(CheckupData?.employeeeyeinformation?.remark || "-") +
                      ", " +
                      (CheckupData?.employeeinvestigationinformation?.remarks || "-")}
                  </td>
                  <td colSpan="6">
                    Audiometry:{" "}
                    {CheckupData?.employeeinvestigationinformation?.audiometry || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    LAB REPORTS:{" "}
                    {CheckupData?.employeebloodinformation?.remarks || "N/A"}
                  </td>
                  <td colSpan="6">
                    SPIROMETRY:{" "}
                    {CheckupData?.employeeinvestigationinformation?.spirometry || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    XRAY REPORTS:{" "}
                    {CheckupData?.employeeinvestigationinformation?.xRayReport || "N/A"}
                  </td>
                  <td colSpan="6">
                    ECG REPORT:{" "}
                    {CheckupData?.employeeinvestigationinformation?.ecgReport || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td colSpan="12">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div>
                        <h5 className="drTitle">CERTIFICATE OF FITNESS:</h5>
                        <p style={{ marginTop: -7 }}>
                          I certify that I have personally examined him/her and as per my opinion
                        </p>
                        <p style={{ marginTop: -7 }}>
                          <span style={{ fontSize: 18, marginRight: 6 }}>
                            {CheckupData?.employeeform33?.unfitReason === "" ? "☑" : "☐"}
                          </span>
                          He/She is fit for the employment
                        </p>
                        <p style={{ marginTop: -7 }}>
                          <span style={{ fontSize: 18, marginRight: 6 }}>
                            {CheckupData?.employeeform33?.unfitReason !== "" ? "☑" : "☐"}
                          </span>
                          He/She not fit for the employment (Temporary/Permanent)
                        </p>
                        <p className="reasonTitle m-0" style={{ height: 32 }}>
                          Reason for unfit: {CheckupData?.employeeform33?.unfitReason || "N/A"}
                        </p>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        {wantsignature ? (
                          <img
                            src={signature}
                            alt="Doctor's Signature"
                            style={{ height: 70, marginBottom: 5 }}
                          />
                        ) : (
                          <div style={{ height: 70, marginBottom: 5 }} />
                        )}
                        <h5 className="drTitle" style={{ margin: 0 }}>
                          Dr.Yatish Shah
                          <p className="mbbsTitle" style={{ margin: 0 }}>
                            M.B.B.S,C.I.H
                          </p>
                        </h5>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>

            </div>

            {/* FOOTER */}
            <div className="adressDiv">
              Verai Mata Lane, Khanderao Market Char Rasta, Raj Mahal Road, Vadodara-390001
              <h5 className="drTitle">
                Mobile: 8320370951 – E-mail: vohs2012@gmail.com
              </h5>
            </div>

            {/* PRINT BUTTONS */}
            <div className="hstack gap-2 justify-content-end d-print-none mt-4">
              <Link to="#" onClick={handlePrintWithSignature} className="btn btn-success">
                <i className="ri-printer-line align-bottom me-1" /> Print with signature
              </Link>
              <Link to="#" onClick={handlePrintWithoutSignature} className="btn btn-success">
                <i className="ri-printer-line align-bottom me-1" /> Print without signature
              </Link>
            </div>

          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MediclaCheckUp;
